module.exports = __webpack_public_path__ + "assets/aanrader.e03ce940.svg";